import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import "./SpeakerBooking.css"; 

const SpeakerBooking = () => {
  const { t, i18n } = useTranslation();
  const { speakerId } = useParams();
  const [speaker, setSpeaker] = useState(null);
  const [loading, setLoading] = useState(true);
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="py-5 bg-light d-flex align-items-center justify-content-center" data-aos="fade-up">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-md-8">
            <div className="bg-white p-5 shadow rounded-4">
              <div className="hourglass-flip">⏳</div>
              <h2 className="fw-bold mt-3 mb-2 text-warning">{t("bookingComing.title")}</h2>
              <p className="fs-5 text-muted">{t("bookingComing.description")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerBooking;
